/**
 * App Users Module Shared Components
 */
import React from 'react'
import { t } from 'i18next'
import loadingImage from 'assets/images/boat-loading.gif'

/**
 * Loading spinner overlay
 */
export const LoadingOverlay = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white"></div>
    </div>
)

/**
 * Loading state with boat animation
 */
export const LoadingState = ({ message = t('Loading, please wait...') }) => (
    <div className="flex flex-col justify-center items-center bg-white h-96 mt-16">
        <img alt="loading" src={loadingImage} className="w-[250px]" />
        <p className="pt-3 text-primary font-semibold">{message}</p>
    </div>
)

/**
 * Error state display
 */
export const ErrorState = ({ message = t('Failed to fetch data!') }) => (
    <div className="flex justify-center items-center bg-white py-5">
        <div className="text-lg text-center">{message}</div>
    </div>
)

/**
 * Empty state with search icon
 */
export const EmptyState = ({ 
    title = t('No records found!'), 
    message = t('Please modify your search criteria and try again.') 
}) => (
    <div className="text-center py-24 bg-gray-50 mt-8 rounded-lg">
        <svg
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
            className="mx-auto h-12 w-12 text-gray-400"
        >
            <path
                d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                strokeWidth={2}
                vectorEffect="non-scaling-stroke"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
        <h3 className="mt-2 text-sm font-semibold text-gray-900">{title}</h3>
        <p className="mt-1 text-sm text-gray-500">{message}</p>
    </div>
)

/**
 * Back button component
 */
export const BackButton = ({ onClick, label = t('Back') }) => (
    <button
        onClick={onClick}
        type="button"
        className="inline-flex items-center gap-x-0.5 rounded-md text-sm text-gray-600"
    >
        <svg 
            className="-ml-0.5 h-5 w-4 rtl:rotate-180" 
            viewBox="0 0 20 20" 
            fill="currentColor"
        >
            <path 
                fillRule="evenodd" 
                d="M17 10a.75.75 0 01-.75.75H5.612l4.158 3.96a.75.75 0 11-1.04 1.08l-5.5-5.25a.75.75 0 010-1.08l5.5-5.25a.75.75 0 111.04 1.08L5.612 9.25H16.25A.75.75 0 0117 10z" 
                clipRule="evenodd" 
            />
        </svg>
        {label}
    </button>
)
